import { languageHelper } from "../../../config/helperFunctions";
import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../components/Modal/DeleteModal";
import { toast } from "react-toastify";

function Vendor() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper("SN"),
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Vendor Name"),
      accessorKey: "vendor_name",
    },
    {
      header: languageHelper("Phone"),
      accessorKey: "phone",
    },
    {
      header: languageHelper("Description"),
      accessorKey: "description",
    },
    {
      header: languageHelper("Added By"),
      accessorKey: "added_by",
      cell: (row) => row.getValue()?.name || "N/A",
    },
    {
      header: languageHelper("Actions"),
      accessorKey: "total",
      cell: (row) => (
        <Dropdown id={row.row.original.id} options={dropdownOptions} />
      ),
    },
  ];
  const [data, setData] = useState([]);
  const [selectedId, setselectedId] = useState(false);
  const buttonData = [
    {
      buttonText: languageHelper("Add Vendor"),
      path: "addVendorForm",
    },
  ];

  const navigate = useNavigate();

  const handleDelete = (id) => {
    axios
      .delete(`${apiKey}/api/rms/admin/vendor/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setselectedId(false);
        fetchData();
        toast.success(res.data.message || "Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(err.response.data.message || "Error deleting vendor", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const dropdownOptions = [
    {
      name: languageHelper("Edit"),
      icon: <FaEdit />,
      func: (id) => {
        // Handle edit action
        navigate(`addVendorForm/${id}`);
      },
    },
    {
      name: languageHelper("Delete"),
      icon: <FaTrash />,
      func: (id) => {
        // Handle delete action
        setselectedId(id);
      },
    },
  ];

  const fetchData = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/vendor`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user?.outlet_id,
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => {
        console.error("Error fetching vendors:", error);
      });
  }, [user?.token, user?.user?.outlet_id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={languageHelper("Vendors")}
        buttonData={buttonData}
      />
      {selectedId && (
        <DeleteModal
          setIsOpen={setselectedId}
          onDelete={() => handleDelete(selectedId)}
        />
      )}
    </main>
  );
}

export default Vendor;
